import { SelectOption } from 'modules/queryBuilder/contexts';
import { EllipsizedContent } from '../ConditionInput/ConditionInput.styles';
import {
  ConditionMultiValueContentWrapper,
  AdditionalCountWrapper,
  AdditionalCountOuterWrapper,
} from './ConditionMultiValue.styles';
import { getMultiValueInputLabelVariables } from './utils';
import { SelectValueType } from 'ui/selects';

type Props<TValue> = {
  values: SelectOption<TValue>[];
  isEmpty: boolean;
  placeholder: string;
  valuesLimit?: number;
  triggerContent?: string;
};

export const ConditionMultiValueContent = <TValue extends SelectValueType>({
  values,
  valuesLimit = 1,
  isEmpty,
  placeholder,
  triggerContent,
}: Props<TValue>) => {
  const { firstValue, cutOffValuesLabel, cutOffValuesLength } = getMultiValueInputLabelVariables(
    values,
    valuesLimit,
  );

  if (isEmpty)
    return <ConditionMultiValueContentWrapper>{placeholder}</ConditionMultiValueContentWrapper>;
  else if (triggerContent)
    return <ConditionMultiValueContentWrapper>{triggerContent}</ConditionMultiValueContentWrapper>;

  return (
    <ConditionMultiValueContentWrapper>
      <EllipsizedContent>{firstValue}</EllipsizedContent>
      {cutOffValuesLength !== 0 && (
        <AdditionalCountOuterWrapper>
          <span>{', '}</span>
          <AdditionalCountWrapper>{cutOffValuesLabel}</AdditionalCountWrapper>
        </AdditionalCountOuterWrapper>
      )}
    </ConditionMultiValueContentWrapper>
  );
};
